import React, {useEffect, useMemo, useState} from 'react';
import WidgetsGrid from "../_layout/WidgetsGrid";
import Page from "../_layout/Page";
import { hasPermsOnIndexesOrReceipts, isKpiAdmin } from '../../services/rolesSvc';
import api from "../../api";
import useNavProject from '../../hooks/useNavProject';
import { useHistory } from 'react-router-dom';

const UnifiedIndicatorsCalculation = ({userCtx}) => {

    const [error, setError] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const [indexes, setIndexes] = useState([]);
    const navProject = useNavProject()
    const history = useHistory()

    useEffect( () => {
        api.get('/info/kpivals',true)
            .then((result)=>{
            setIsLoaded(true);
            setIndexes(result)
            })
            .catch(()=>{
                setIsLoaded(true);
                setError(error);
            })
    }, []);


    const widgetItems = [
        { url: '/indexes/calculation-unified-part/receipts', name: 'Поступления от научной и иновационной деятельности', navName: 'Поступления' },
    ];
    return (
        <React.Fragment>
            <Page header="Данные для расчета фактических значений по показателям" className="indexes-page">
                <WidgetsGrid items={widgetItems.filter((w) => !w.show || w.show(userCtx.perms))} onClick={(item) => {
                    navProject.setIndexName(item.navName);
                    history.push(`${item.url}`)
                }} />
            </Page>
        </React.Fragment>
    );
};

export default UnifiedIndicatorsCalculation;
